import { Modal } from "antd";
import React from "react";
import SectionTitle from "./SectionTitle";
import { useNavigate } from "react-router-dom";

type Props = {
  cancleLink: string;
  width: number;
  children: React.ReactNode;
  title: string;
  subtitle?: string;
};

const DashModal = (props: Props) => {
  const router = useNavigate();
  return (
    <Modal
      width={props.width}
      title={<SectionTitle title={props.title} subtitle={props.subtitle} />}
      onCancel={() => {
        router(props.cancleLink);
      }}
      footer={null}
      open={true}
    >
      {props.children}
    </Modal>
  );
};

export default DashModal;
